
import React from 'react';
import { cn } from '@/lib/utils';

interface SkillBadgeProps {
	label: string;
	size?: 'sm' | 'md';
	variant?: 'default' | 'primary';
	className?: string;
}

export const SkillBadge: React.FC<SkillBadgeProps> = ({ 
	label, 
	size = 'md',
	variant = 'default',
	className
}) => {
	const sizeClasses = size === 'sm' 
		? 'px-2 py-0.5 text-xs' 
		: 'px-3 py-1 text-sm';
	
	const variantClasses = variant === 'primary'
		? 'bg-primary/10 text-primary border border-primary/20'
		: 'bg-blue-50 text-blue-700 border border-blue-100';
	
	return (
		<span 
			className={cn(
				variantClasses,
				sizeClasses,
				'rounded-full inline-block font-medium',
				className
			)}
		>
			{label}
		</span>
	);
};
